import { CLOSED_LOST_STAGE_CODE, CLOSED_WON_STAGE_CODE } from '@gh/builder-shared-data';

/**
 * Stages a user may pick by hand. Closed Won is reached by Complete Sale and Closed Lost through
 * Not Proceeding with a reason, so neither is offered, except as the folder's current stage so an
 * existing value still shows. Mirrors ManualStageChangePolicy on the backend.
 */
export function selectableStageOptions<T extends { id: string | number }>(stages: T[] | undefined,
                                                                          currentStage?: string | number | null): T[] {
  const current = currentStage == null ? '' : `${currentStage}`;
  return (stages || []).filter((stage) => {
    const code = `${stage.id}`;
    return code === current || (code !== `${CLOSED_LOST_STAGE_CODE}` && code !== `${CLOSED_WON_STAGE_CODE}`);
  });
}
